import {
    TAX_REPORT_SUCCESS,
    TAX_REPORT_LOADING
} from '../actions/TaxAction';

const initialState = {
    amazon: {
        taxReportData: null,
        isLoading: true
    },
    shopify: {
        taxReportData: null,
        isLoading: true
    },
    wholesale: {
        taxReportData: null,
        isLoading: true
    },
};

const taxReport = (state = initialState, action = {}) => {

    switch (action.type) {
        case TAX_REPORT_SUCCESS:
            return {
                ...state, taxReportData: action.data, isLoading: false
            };
        case TAX_REPORT_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default taxReport;
